import React from 'react';

interface Props {
  className?: string;
}

/**
 * Bandeau du bas, présent sur tous les écrans.
 *
 * La plateforme est un outil du programme : ses signatures (le PEV, le
 * ministère de tutelle, Gavi qui finance l'appui, et OmnIA qui l'opère)
 * restent visibles quel que soit l'écran ouvert, réparties sur toute la
 * largeur.
 */
const LOGOS = [
  { src: '/logos/pev.png', alt: 'Programme Élargi de Vaccination, Guinée', classe: 'h-8' },
  { src: '/logos/ministere-sante.png', alt: "Ministère de la Santé et de l'Hygiène Publique", classe: 'h-8' },
  { src: '/logos/gavi.png', alt: 'Gavi, the Vaccine Alliance', classe: 'h-7' },
  { src: '/logo-omnia.svg', alt: 'OmnIA', classe: 'h-6' },
];

const BandeauInstitutionnel: React.FC<Props> = ({ className = '' }) => (
  <footer
    className={`border-t border-eg-bordure bg-eg-blanc/90 backdrop-blur ${className}`}
  >
    <div className="flex flex-col gap-1 px-4 py-2 sm:px-8">
      <div className="flex w-full items-center justify-around gap-4">
        {LOGOS.map((logo) => (
          <img key={logo.src} src={logo.src} alt={logo.alt} className={`${logo.classe} w-auto object-contain`} />
        ))}
      </div>
      <p className="text-center text-[10.5px] leading-snug text-eg-estompe">
        Programme Élargi de Vaccination · Ministère de la Santé et de l'Hygiène Publique
        <span className="hidden md:inline"> · République de Guinée</span>
      </p>
    </div>
  </footer>
);

export default BandeauInstitutionnel;
